// extracted by mini-css-extract-plugin
module.exports = {"pingCopyIcon":"style_pingCopyIcon__Vzwp2"};